import { useEffect, useState } from "react";
import api from "../api/api";

function AdminVendors() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/vendors")
      .then(res => setVendors(Array.isArray(res.data) ? res.data : []))
      .catch(() => setVendors([]))
      .finally(() => setLoading(false));
  }, []);

  const toggleVendor = (id) => {
    api.put(`/admin/vendor/toggle/${id}`).then(() => {
      setVendors(prev =>
        prev.map(v => v.vendorId === id ? { ...v, active: !v.active } : v)
      );
    });
  };

  if (loading) return <p className="text-muted fs-13">Loading vendors…</p>;

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">All Vendors</div>
        <span className="badge badge-muted">{vendors.length} total</span>
      </div>

      {vendors.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🚴</div>
          <div className="empty-title">No vendors yet</div>
          <div className="empty-sub">Add your first vendor above</div>
        </div>
      ) : (
        <div className="card-body no-pad">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Vendor</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {vendors.map(v => (
                  <tr key={v.vendorId}>
                    <td>
                      <div className="flex-center gap-8">
                        <div className="user-avatar" style={{ width: 32, height: 32, fontSize: 12 }}>
                          {v.name[0]}
                        </div>
                        <strong>{v.name}</strong>
                      </div>
                    </td>
                    <td className="text-muted fs-13">{v.phone}</td>
                    <td>
                      <span className={`badge ${v.active ? "badge-success" : "badge-danger"}`}>
                        {v.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <button
                        className={`btn btn-sm ${v.active ? "btn-outline" : "btn-success"}`}
                        onClick={() => toggleVendor(v.vendorId)}
                      >
                        {v.active ? "Deactivate" : "Activate"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminVendors;
